import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.flat-map.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.unscopables.flat-map.js";
import "core-js/modules/es.array-buffer.constructor.js";
import "core-js/modules/es.array-buffer.slice.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/es.string.match.js";
import "core-js/modules/es.string.pad-start.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.string.trim.js";
import "core-js/modules/es.typed-array.uint8-array.js";
import "core-js/modules/es.typed-array.copy-within.js";
import "core-js/modules/es.typed-array.every.js";
import "core-js/modules/es.typed-array.fill.js";
import "core-js/modules/es.typed-array.filter.js";
import "core-js/modules/es.typed-array.find.js";
import "core-js/modules/es.typed-array.find-index.js";
import "core-js/modules/es.typed-array.for-each.js";
import "core-js/modules/es.typed-array.includes.js";
import "core-js/modules/es.typed-array.index-of.js";
import "core-js/modules/es.typed-array.iterator.js";
import "core-js/modules/es.typed-array.join.js";
import "core-js/modules/es.typed-array.last-index-of.js";
import "core-js/modules/es.typed-array.map.js";
import "core-js/modules/es.typed-array.reduce.js";
import "core-js/modules/es.typed-array.reduce-right.js";
import "core-js/modules/es.typed-array.reverse.js";
import "core-js/modules/es.typed-array.set.js";
import "core-js/modules/es.typed-array.slice.js";
import "core-js/modules/es.typed-array.some.js";
import "core-js/modules/es.typed-array.sort.js";
import "core-js/modules/es.typed-array.subarray.js";
import "core-js/modules/es.typed-array.to-locale-string.js";
import "core-js/modules/es.typed-array.to-string.js";
import "core-js/modules/esnext.promise.all-settled.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/web.dom-collections.iterator.js";
// SDK v3 loads Open Sans from Google Fonts CDN when given `fontFamily: 'Open Sans'`,
// injecting weight 700 into the main document. This causes hub elements that use
// `font-weight: bold` (which maps to 700) to render heavier than intended, since the
// hub only declares weights 400 and 600 and relies on weight 600 being the nearest match.
//
// Fix: pass `fontDetails` with our self-hosted woff2 URLs so the SDK uses those files
// directly and never touches Google Fonts. The fonts are preloaded in head.ejs so the
// fetch() calls here are cache hits. If they fail, we fall back to `sans-serif` to keep
// hub font rendering intact.

// Weight 700 is explicitly mapped to our semibold (600) woff2. Without it the SDK (and
// the Widget Studio runtime) fall back to loading all weights from Google Fonts CDN
// (wght@100;200;300;…;900) when they cannot find 700 in fontDetails. Providing 700
// pointing to our 600 file satisfies the SDK's minimum-weight requirement while keeping
// the hub visually unchanged — bold elements that previously fell back to 600 (nearest
// match) continue to do so.

function findFontFaceWoff2Url(family, weight) {
  for (var _i = 0, _Array$from = Array.from(document.styleSheets); _i < _Array$from.length; _i++) {
    var sheet = _Array$from[_i];
    try {
      for (var _i2 = 0, _Array$from2 = Array.from(sheet.cssRules); _i2 < _Array$from2.length; _i2++) {
        var rule = _Array$from2[_i2];
        if (rule instanceof CSSFontFaceRule && rule.style.getPropertyValue('font-family').replace(/["']/g, '').trim() === family && rule.style.getPropertyValue('font-weight') === weight) {
          var src = rule.style.getPropertyValue('src');
          var match = src.match(/url\(["']?([^"')]+\.woff2)["']?\)/);
          return match === null || match === void 0 ? void 0 : match[1];
        }
      }
    } catch (_unused) {
      // cross-origin sheet
    }
  }
}
function buildFontDetail(_x, _x2) {
  return _buildFontDetail.apply(this, arguments);
} // Cached on first call — font files don't change between SDK initialisations
function _buildFontDetail() {
  _buildFontDetail = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(fontUrl, fontWeight) {
    var response, buffer, hashBuffer, sha256Checksum;
    return _regeneratorRuntime.wrap(function (_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.next = 1;
          return fetch(fontUrl, {
            credentials: 'omit'
          });
        case 1:
          response = _context.sent;
          if (response.ok) {
            _context.next = 2;
            break;
          }
          throw new Error("Failed to fetch font: ".concat(response.status));
        case 2:
          _context.next = 3;
          return response.arrayBuffer();
        case 3:
          buffer = _context.sent;
          _context.next = 4;
          return crypto.subtle.digest('SHA-256', buffer);
        case 4:
          hashBuffer = _context.sent;
          sha256Checksum = Array.from(new Uint8Array(hashBuffer)).map(function (b) {
            return b.toString(16).padStart(2, '0');
          }).join('');
          return _context.abrupt("return", {
            fontWeight: fontWeight,
            fontStyle: 'normal',
            fontUrl: fontUrl,
            sha256Checksum: sha256Checksum,
            fileSize: buffer.byteLength
          });
        case 5:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return _buildFontDetail.apply(this, arguments);
}
var openSansFontDetailsCache;
export function getOpenSansFontDetails() {
  if (!openSansFontDetailsCache) {
    var toFetch = [['400', 400], ['600', 600]].flatMap(function (_ref) {
      var _ref2 = _slicedToArray(_ref, 2),
        cssWeight = _ref2[0],
        fontWeight = _ref2[1];
      var url = findFontFaceWoff2Url('Open Sans', cssWeight);
      return url ? [[url, fontWeight]] : [];
    });
    openSansFontDetailsCache = Promise.allSettled(toFetch.map(function (_ref3) {
      var _ref4 = _slicedToArray(_ref3, 2),
        url = _ref4[0],
        weight = _ref4[1];
      return buildFontDetail(url, weight);
    })).then(function (results) {
      var details = results.filter(function (r) {
        return r.status === 'fulfilled';
      }).map(function (r) {
        return r.value;
      });

      // Alias weight 700 → semibold (600) without re-fetching: the SDK requires
      // 700 in fontDetails or it falls back to loading all weights from Google Fonts.
      var semibold = details.find(function (d) {
        return d.fontWeight === 600;
      });
      if (semibold) {
        details.push(_objectSpread(_objectSpread({}, semibold), {}, {
          fontWeight: 700
        }));
      }
      return details;
    });
  }
  return openSansFontDetailsCache;
}